<template>
  <div class="flex flex-col gap-3">
    <ui-table class="text-sm">
      <ui-table-header>
        <ui-table-row class="hover:bg-transparent [&_th]:text-xs [&_th]:font-semibold [&_th]:text-muted-foreground">
          <ui-table-head></ui-table-head>
          <ui-table-head class="text-right">{{ tr('Net') }}</ui-table-head>
          <ui-table-head class="text-right">{{ tr('Gross') }}</ui-table-head>
        </ui-table-row>
      </ui-table-header>
      <ui-table-body>
        <ui-table-row v-for="row in entity.items" :key="row.id">
          <ui-table-cell class="whitespace-normal">{{ row.title }}</ui-table-cell>
          <ui-table-cell class="text-right tabular-nums">{{ formatPrice(row.net, '€') }}</ui-table-cell>
          <ui-table-cell class="text-right tabular-nums">{{ formatPrice(row.gross, '€') }}</ui-table-cell>
        </ui-table-row>
      </ui-table-body>
    </ui-table>

    <dl class="m-0 flex flex-col items-end gap-0.5 text-sm">
      <div class="flex gap-2"><dt class="text-muted-foreground">{{ tr('Total net') }}:</dt><dd class="m-0 font-semibold tabular-nums">{{ formatPrice(entity.net, '€') }}</dd></div>
      <div class="flex gap-2"><dt class="text-muted-foreground">{{ tr('Total gross') }}:</dt><dd class="m-0 font-semibold tabular-nums">{{ formatPrice(entity.gross, '€') }}</dd></div>
    </dl>
  </div>
</template>

<script>
import PaymentHistory from '@/entities/PaymentHistory';
import { formatPrice } from '@/utils/number.js';

export default {
  name: 'PaymentHistoryDetails',
  props: {
    entity: {
      required: true,
      type: PaymentHistory,
    },
  },
  methods: {
    formatPrice,
  },
};
</script>
